module.exports = __webpack_public_path__ + "files/0d3cf2c2f2f4230c374b148a7ee6f75d.png";